<template>
  <section id="faqs" class="overflow-hidden">
    <admin-app-bar />
    <v-row no-gutters>
      <v-col cols="12" class="welcome-background"></v-col>

      <v-col class="pa-5" cols="12">
        <v-row align="center" justify="center">
          <v-col cols="12" md="8" lg="8">
            <heading tag="h1">FAQs</heading>
            <base-text
              >Have questions prior to your Virtual House Pro call? Read below
              to find answers to our most frequently asked questions.</base-text
            >

            <v-row>
              <v-expansion-panels>
                <v-expansion-panel v-for="(faq, i) in faqs" :key="i">
                  <v-expansion-panel-header
                    class="align-center"
                    expand-icon="fa-chevron-down"
                  >
                    <heading v-text="faq.question" tag="h3"></heading>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <base-text
                      v-text="faq.answer"
                      style="margin: 0"
                    ></base-text>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import UtilsMixin from "../../mixins/UtilsMixin";
import BaseText from "@/components/base/Text";
import Heading from "@/components/base/Heading";
import AdminAppBar from "@/components/core/AdminAppBar";

export default {
  name: "faqs",
  mixins: [UtilsMixin],
  components: {
    BaseText,
    Heading,
    AdminAppBar,
  },
  data() {
    return {
      faqs: [
        {
          question: "What does it cost?",
          answer:
            "Each 25 minute session is $75. If you book back to back sessions (example: 9-9:25 and 9:30-9:55) you will get the 5 minutes free in between sessions, but you will need to book sessions separately at this time. Sign up for your 25 minute session for $75 today!",
        },
        {
          question: "How do I get ready for a Facetime VHP call?",
          answer:
            "In order to participate in a Facetime call, you will need a handheld Apple device with a camera (iPhone, iPad, iPod Touch).  Your Facetime account is directly linked to your Apple ID.  Please make sure you have Facetime setup on your device.  Prior to your scheduled time, we will initiate the call via the phone number or email you provided to us.",
        },
        {
          question: "How do I get ready for a Zoom VHP call?",
          answer:
            "In order to participate in a Zoom call, you will need the Zoom mobile app installed on your device (iPhone, iPad, tablet).  Prior to your scheduled time, we will email you the zoom call info including the Zoom link and password.",
        },
        {
          question: "What should I have with me for the call?",
          answer:
            "We recommend that you have a tape measure on hand and that you write down all your questions before hand.  This will help us be as efficient as possible!",
        },
        {
          question: "Is one 25 minute time slot long enough?",
          answer:
            "For most calls, 25 minutes is plenty of time.  However, for virtual home walk throughs, we recommend 2 time slots (roughly 50 minutes).",
        },
        {
          question: "Do I need prior experience in DIY projects?",
          answer:
            "Not at all!  Depending on your skill level and the project we should be able to walk you through step by step.",
        },
        {
          question: "Are you a real estate agency?",
          answer: "Nope.  We do not sell real estate.",
        },
        {
          question: "Who can sign up for a Virtual House Pro call?",
          answer:
            "Anyone!  As long as you have a device and a reliable internet connection, we can work with you no matter where you are in the US.",
        },
        {
          question: "How can I recommend you to friends and family?",
          answer:
            "It's easy!  Just sent them a link to this website.  You can also follow us on Instagram at @virtualhousepro",
        },
      ],
    };
  },
  computed: {
    getStatus() {
      return this.$store.getters.status;
    },
    bookingDetails() {
      return this.$store.getters.bookingDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome-background {
  background-image: url("../../assets/vhp_bkg@2x.jpg");
  background-size: cover;
  background-position: center center;
  position: relative;
  width: 100%;
  height: 28vh;

  @media (min-width: 768px) {
    height: 45vh;
  }

  .welcome-logo {
    position: absolute;
    top: 5%;
    left: 5%;
  }
}
</style>
